/**
 * created by lei lei
 *  公共头部
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";

 class BseTitle extends Component {
    static defaultProps = {
        title:'大标题'
    };
    static propTypes = {
        title:PropTypes.string.isRequired,//标题
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <div>
                <div style={{
                    display: 'flex',
                    background: '#ffffff',
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <b style={{
                        color: newSecondSelectColor,
                        fontSize: 18,
                        paddingBottom: 20,
                        height: 58,
                        lineHeight: '58px',
                        marginLeft: 20
                    }}>
                        {this.props.title}
                    </b>
                </div>
            </div>
        )
    }

}
function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(BseTitle);